import React, { useEffect, useState } from "react";
import { Select } from "../../tailwind/molecules/Select";
import MailerPanel from "./MailerPanel";
import { Breadcrumb, Heading, Spinner } from "../../common/atoms";
import { companyMailerApi } from "../../../services";
import { handleAppError } from "../../handlers";

const BenefitAdoptionMailerDashboard = () => {
  const [pageloading, setPageLoading] = useState(true);
  const [benefitsMailers, setBenefitsMailers] = useState([]);
  const [selectedBenefitId, setSelectedBenefitId] = useState(null);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchMailers();
    setPageLoading(false);
  }, []);

  const fetchMailers = async () => {
    companyMailerApi.benefit_adoption_mailers(
      {},
      (res) => {
        let mailers = res.data?.mailer || [];
        setBenefitsMailers(mailers || []);
        setSelectedBenefitId(mailers[0]?.id || null);
        setSelectedBenefit(mailers[0] || null);
        setOptions(mailers.map((benefit) => ({
          label: `${benefit.benefit_name}`,
          value: benefit.id
        })));
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  const selectBenefit = (value) => {
    const selected = benefitsMailers.find((benefit) => benefit.id === value);
    setSelectedBenefitId(value);
    setSelectedBenefit(selected || null);
  };

  const pageReload = (value) =>  setPageLoading(value);

  return (
    <Spinner visible={pageloading}>
      <Breadcrumb list={[{ text:'Engagement', link:'/stepathon' }, { text:'Benefit Adoption Mailers', link:'#' }]} classes='mb-1' />
      <Heading mainHeading="Benefit Adoption Mailers" classes='mt-2'/>
      <p className='text-ts-md leading-relaxed text-gray-600'>This section displays personalized benefit mailers, segmented by grade where applicable, to boost engagement and adoption.</p>

      <div className="container mx-auto px-4">
        <div className="mb-ds-7 rounded-ds-lg border border-gray-300 bg-white shadow-ds-sm">
          <div className="p-ds-5 space-y-ds-4">
            <div className="flex flex-col gap-ds-2 sm:flex-row sm:items-center sm:justify-end">
              <label htmlFor="benefit-select" className="text-ts-xs font-semibold uppercase tracking-[0.1em] text-gray-500 sm:mr-ds-3">
                Benefit
              </label>
              <Select
                id="benefit-select"
                value={selectedBenefitId || ""}
                onChange={selectBenefit}
                options={options}
                classes="w-56"
                placeholder="Select benefit"
              />
            </div>
            {selectedBenefit && (
              <div className="rounded-ds-lg border border-ds-brand-200 bg-ds-brand-lt px-ds-4 py-ds-3">
                <p className="text-ts-md leading-relaxed text-gray-800">
                  {selectedBenefit.description}
                </p>
              </div>
            )}
          </div>
        </div>

        <MailerPanel selectedBenefit={selectedBenefit} fetchMailers={fetchMailers} setPageLoading={pageReload} pageloading={pageloading} />
      </div>
    </Spinner>
  );
};

export default BenefitAdoptionMailerDashboard;